import React, { Component } from "react";
import Helping from "../../helpers/Helping";
import { create, update } from "../../services/news.service";
import { setErrorFields, validateField, clearErrorFields, validateCallback } from "../../helpers/validationHelpers";
import { connect } from "react-redux";
import { MESSAGE } from '../../config/index';
import { API_URL } from '../../config/urls';
import { setProfileError, addCurrentRoute } from '../../actions/profile_action';
import { Progress } from 'react-sweet-progress';
import Notification from "../layout/Notification";
import LoadingButton from "../fields/LoadingButton";
import Service from '../../helpers/service';
import { GET_NEWS, LIST_NEWS } from '../../config/routes';
import jQuery from 'jquery';
import $ from 'jquery';

const { EMPTY, CREATE, UPDATE, SYNC } = MESSAGE;
class Create extends Component {
    constructor(props) {
        super(props);

        this.state = {
            pageTitle: 'Add News',
            buttonTitle: 'Save',
            link: '',
            platform: 'all',
            title: '',
            status: 'publish',
            description: '',
            short_description: '',
            imageUrl: '',
            imageUrlPercent: 0,
            imageUrlConverted: '',
            selectedFile: null,
            image: '',
            filters: [],
            url: API_URL.ADMIN_TRADING_API + GET_NEWS,
            routeName: LIST_NEWS,
            error_message: '',
            error_type: '',
            isLoading: true,
            btnIsDisable: false,
        };
        this.onUpdate = this.onUpdate.bind(this);
        this.onSave = this.onSave.bind(this);
    }

    setErrorOnApiCall = () => {
        setProfileError((res) =>
            this.setState({ ...res })
        );
    };

    removeNetworkError = () => {
        this.setState({ ...Helping.clearNetworkRequest() });
    };

    setValidationCallback = () => {
        validateCallback((res) => this.setState({ ...res }));
    };

    scrollToTop = () => {
        $('.addButton-slide').animate({ scrollTop: 0 }, 'slow');
    }

    handleChange = async (e) => {
        const { name, value } = e.target;
        this.setState({ [name]: value });

        if (name === 'link')
            this.setState({ ...(await validateField('string', name, value, '')) });
        if (name === 'title')
            this.setState({ ...(await validateField('string', name, value, '', 1)) });
        if (name === 'platform')
            this.setState({ ...(await validateField('string', name, value, '', 1)) });
        if (name === 'short_description')
            this.setState({ ...(await validateField('string', name, value, '', 3)) });
        if (name === 'description')
            this.setState({ ...(await validateField('string', name, value, '', 3)) });
        if (name === 'imageUrl')
            this.setState({ ...(await validateField('file', name, e, 'image', '', 'image', {}, false, 'news/')), });
    }

    componentDidMount() {
        let that = this;
        this.setErrorOnApiCall();
        this.setValidationCallback();

        if (!this.props.id) {
            this.setState({
                isLoading: false,
            });
        }
        if (this.props.id) {
            let id = this.props.id;
            that.setState({
                pageTitle: 'Edit News',
                buttonTitle: 'Update',
            });

            that.getById(id);
        }

        $(".close-slide").click(function () {
            that.resetForm();
            that.removeNetworkError();
            that.setState({
                pageTitle: 'Add News',
                buttonTitle: 'Save'
            })
            that.props.closeEditModal();
        });
    }

    checkEmptyFields = () => {
        let { state } = this,
            formHasError = false;

        if (state.title != null && state.title.length < 1) {
            let errorObject = setErrorFields(
                'title',
                Helping.getMessageString(EMPTY, 'Title')
            );
            this.setState({ ...errorObject });
            formHasError = true;
        }

        if (state.platform != null && state.platform.length < 1) {
            let errorObject = setErrorFields(
                'platform',
                Helping.getMessageString(EMPTY, 'Platform')
            );
            this.setState({ ...errorObject });
            formHasError = true;
        }

        if (state.description != null && state.description.length < 1) {

            if (state.platform != null && state.platform.toLowerCase() !== 'web') {
                let errorObject = setErrorFields(
                    'description',
                    Helping.getMessageString(EMPTY, 'Description')
                );
                this.setState({ ...errorObject });
                formHasError = true;
            }
            else {
                let errorObject = clearErrorFields('description');
                this.setState({ ...errorObject });
            }
        }

        if (state.short_description !== null && state.short_description.length < 1) {

            if (state.platform != null && state.platform.toLowerCase() !== 'mobile') {
                let errorObject = setErrorFields(
                    'short_description',
                    Helping.getMessageString(EMPTY, 'Short Description')
                );
                this.setState({ ...errorObject });
                formHasError = true;
            }
            else {
                let errorObject = clearErrorFields('short_description');
                this.setState({ ...errorObject });
            }
        }

        if (state.imageUrl != null && state.imageUrl.length < 1) {
            if (state.platform && state.platform.toLowerCase() !== 'web') {
                let errorObject = setErrorFields(
                    'imageUrl',
                    Helping.getMessageString(EMPTY, 'Image')
                );
                this.setState({ ...errorObject });
                formHasError = true;
            }
            else {
                let errorObject = clearErrorFields('imageUrl');
                this.setState({ ...errorObject });
            }
        }
        return formHasError;
    };

    handleAddElementInArray = (e) => {
        e.preventDefault();

        this.setState((previousState) => {
            return previousState.filters.push({ key: "", value: "" });
        })
    }

    handleArrayValueChange = (target, index) => {
        this.setState((previousState) => {
            let currentContent = previousState.filters[index];
            currentContent[target.name] = target.value;
            return previousState
        })
    }

    handleArrayRemove = (e, index) => {
        e.preventDefault();

        const result = Helping.removeArrayFromIndex(this.state.filters, index);
        this.setState({ filters: result })
    }

    getById(id) {
        var $this = this;

        let data = {
            action: "get-by-id",
            id: id
        }
        Service.postCall(API_URL.ADMIN_TRADING_API + GET_NEWS, data)
            .then((response) => {
                var news = response.data.payload.news;
                var filters = news.filters;
                var content = [];

                if (filters != null) {
                    for (var key in filters) {
                        if (filters.hasOwnProperty(key)) {
                            content.push({
                                key,
                                value: filters[key]
                            });
                        }
                    }
                }

                $this.setState({
                    link: news.link,
                    title: news.title,
                    status: news.status,
                    description: news.description ? news.description : "",
                    short_description: news.short_description ? news.short_description : "",
                    platform: news.platform,
                    filters: content,
                    imageUrl: news.imageUrl ? news.imageUrl : "",
                    imageUrlConverted: '',
                    imageUrlPercent: 0,
                    isLoading: false,
                });
            })
            .catch((error) => {
                if (error.response) {
                    Helping.redirectToLogin(error);
                    return $this.setState({
                        error_message: error.response.data.message,
                        error_type: 'danger',
                        isLoading: false,
                    });
                }
                return this.setState({
                    isLoading: false,
                    ...Helping.setNetworkRequestError(error, 'fetching news'),
                });
            });
    }

    removeImage = (name, id) => {
        $(`#${id}`).val('');
        
        this.setState({ [name]: "", [`${name}Percent`]: 0 });
    }

    resetForm = () => {
        this.setState({
            link: '',
            platform: 'all',
            title: '',
            description: '',
            short_description: '',
            imageUrl: '',
            imageUrlConverted: '',
            selectedFile: null,
            image: '',
            filters: [],
            error_filters_key_message: '',
            error_filters_value_message: '',
            isLoading: true,
            btnIsDisable: false,
            error_title_message: '',
            error_link_message: '',
            error_description_message: '',
            error_short_description_message: '',
            error_imageUrl_message: '',
            imageUrlPercent: 0
        })
    }

    onSave(event) {
        event.preventDefault();

        let $this = this;
        let formHasError = this.checkEmptyFields();
        if (formHasError) {
            window.scrollToErrorFields();
            return;
        }

        this.setState({
            btnIsDisable: true,
            error_message: "",
            error_type: ""
        });


        let filters = {}, stateFilter = this.state.filters;
        for (let index = 0; index < stateFilter.length; index++) {
            let currentFilterKey = stateFilter[index]['key'],
                currentFilterValue = stateFilter[index]['value'];
            filters = {
                ...filters,
                [currentFilterKey]: currentFilterValue
            };
        }

        let platform = $this.state.platform.toLowerCase(),
            data = {
                action: 'create',
                link: $this.state.link,
                title: $this.state.title,
                description: platform !== 'web' ? $this.state.description : "",
                platform: platform,
                status: $this.state.status.toLowerCase(),
                short_description: platform !== 'mobile' ? $this.state.short_description : "",
                image: platform !== 'web' ? $this.state.imageUrl : "",
                filters: !jQuery.isEmptyObject(filters) ? JSON.stringify(filters) : null
            };

        Service.postCall(API_URL.ADMIN_TRADING_API + GET_NEWS, data)
            .then((response) => {
                this.props.create(response.data.payload.news);
                this.setState(
                    {
                        error_message: Helping.getMessageString(CREATE, 'News'),
                        error_type: 'success',
                        btnIsDisable: false,
                        imageUrlPercent: 0
                    },
                    () => { this.scrollToTop(); this.resetForm() }
                );
            })
            .catch((error) => {
                if (error.response) {
                    Helping.redirectToLogin(error);
                    return $this.setState(
                        {
                            error_message: error.response.data.message,
                            error_type: 'danger',
                            btnIsDisable: false,
                        },
                        () => { this.scrollToTop(); }
                    );
                }
                return this.setState(
                    {
                        isLoading: false,
                        btnIsDisable: false,
                        ...Helping.setNetworkRequestError(error, 'creating news'),
                    },
                    () => { this.scrollToTop(); }
                );
            });
    }

    onUpdate(event) {
        event.preventDefault();

        let $this = this;
        let formHasError = this.checkEmptyFields();
        if (formHasError) {
            window.scrollToErrorFields();
            return;
        }

        this.setState({
            btnIsDisable: true,
            error_message: "",
            error_type: ""
        });

        let filters = {}, stateFilter = this.state.filters;
        for (let index = 0; index < stateFilter.length; index++) {
            let currentFilterKey = stateFilter[index]['key'],
                currentFilterValue = stateFilter[index]['value'];
            filters = {
                ...filters,
                [currentFilterKey]: currentFilterValue
            };
        }

        let platform = $this.state.platform.toLowerCase(),
            data = {
                action: 'update',
                id: this.props.id,
                link: $this.state.link,
                title: $this.state.title,
                description: platform !== 'web' ? $this.state.description : "",
                platform: platform,
                status: $this.state.status.toLowerCase(),
                short_description: platform !== 'mobile' ? $this.state.short_description : "",
                image: platform !== 'web' ? $this.state.imageUrl : "",
                filters: !jQuery.isEmptyObject(filters) ? JSON.stringify(filters) : null
            };

        Service.postCall(API_URL.ADMIN_TRADING_API + GET_NEWS, data)
            .then((response) => {
                $this.props.update(response.data.payload.news);

                $this.setState({
                    error_message: Helping.getMessageString(UPDATE, 'News'),
                    error_type: 'success',
                    btnIsDisable: false,
                    imageUrlPercent: 0
                },
                    () => { this.scrollToTop(); this.resetForm() })
            })
            .catch((error) => {
                if (error.response) {
                    Helping.redirectToLogin(error);
                    return $this.setState(
                        {
                            error_message: error.response.data.message,
                            error_type: 'danger',
                            btnIsDisable: false,
                        },
                        () => { this.scrollToTop(); }
                    );
                }
                return this.setState(
                    {
                        isLoading: false,
                        btnIsDisable: false,
                        ...Helping.setNetworkRequestError(error, 'updating news'),
                    },
                    () => { this.scrollToTop(); }
                );
            });
    }

    render() {
        return (
            <div class="addButton-slide right-slider add-news">
                <div class="slide-top">
                    <div class="slide-header">
                        <h4 class="title">{this.state.pageTitle}</h4>
                        <span class="caption">{this.state.pageTitle} and give information about them.</span>
                    </div>
                </div>

                {this.state.error_message &&
                    <Notification
                        type={this.state.error_type}
                        message={this.state.error_message}
                        callback={this.removeNetworkError}
                    />
                }

                <form class="info">
                    <div class="form-group">
                        <label for="newsTitle">Title</label>
                        <input type="text" name="title" value={this.state.title} class={`form-control ${this.state.error_title_message ? 'error-input' : ''}`} id="newsTitle" onChange={(e) => this.handleChange(e)} />
                        <span className="error-msg">{this.state.error_title_message}</span>
                    </div>
                    <div class="form-group">
                        <label for="newslink">Link</label>
                        <input type="text" value={this.state.link} name="link" class={`form-control ${this.state.error_link_message ? 'error-input' : ''}`} id="newslink" onChange={(e) => this.handleChange(e)} />
                        <span className="error-msg">{this.state.error_link_message}</span>
                    </div>
                    <div class="form-group">
                        <label for="status">Status</label>
                        <select class={`form-select ${this.state.error_status_message ? 'error-input' : ''}`} name="status" aria-label="" id="status" value={this.state.status} onChange={(e) => this.handleChange(e)}>
                            <option value='publish'>Publish</option>
                            <option value='unpublish'>Unpublish</option>
                        </select>
                        <span className="error-msg">{this.state.error_status_message}</span>
                    </div>
                    <div class="form-group-tabs">
                        <label for="">Platform</label>
                        <div class="category-tabs">
                            <ul class="nav nav-pills" name="platform">
                                <li class="tab-item">
                                    <a class={this.state.platform === 'all' ? "active" : ""}
                                        id="all" href="#All" data-toggle="tab"
                                        onClick={(e) => this.setState({ platform: e.target.id })}>All
                                    </a>
                                </li>
                                <li class="tab-item">
                                    <a class={this.state.platform === 'web' ? "active" : ""}
                                        href="#Web" id="web" data-toggle="tab"
                                        onClick={(e) => this.setState({ platform: e.target.id })}>Web
                                    </a>
                                </li>
                                <li class="tab-item">
                                    <a class={this.state.platform === 'mobile' ? "active" : ""}
                                        href="#Mobile" id="mobile" data-toggle="tab"
                                        onClick={(e) => this.setState({ platform: e.target.id })}>Mobile
                                    </a>
                                </li>
                            </ul>
                        </div>

                        <div class="tab-content">
                            <div class={`tab-pane ${this.state.platform === 'all' ? "active" : ""}`} id="All">
                                <div class="form-group">
                                    <label for="shortDetail">Short Description</label>
                                    <input type="text" name="short_description" value={this.state.short_description} class={`form-control ${this.state.error_short_description_message ? 'error-input' : ''}`} id="shortDetail" onChange={(e) => this.handleChange(e)} />
                                    <span className="error-msg">{this.state.error_short_description_message}</span>
                                </div>

                                <div class="form-group">
                                    <label for="newsDescription">Description</label>
                                    <textarea class={`form-control ${this.state.error_description_message ? 'error-input' : ''}`} name="description" value={this.state.description} id="newsDescription" rows="3" onChange={(e) => this.handleChange(e)}></textarea>
                                    <span className="error-msg">{this.state.error_description_message}</span>
                                </div>

                                <div class='form-group'>
                                    <div class={`ImgField ${this.state.error_imageUrl_message ? 'error-input' : ''}`}>
                                        {this.state.imageUrl &&
                                            <div className="img-holder">
                                                <span class="remove-img" title="Remove News Image" onClick={() => this.removeImage('imageUrl', 'myFile')}>&times;</span>
                                                <img src={this.state.imageUrl} />
                                            </div>
                                        }
                                        <label class="imgFieldArea" for="myFile">

                                            {!this.state.imageUrl &&
                                                <span class="icon fileImg">
                                                    <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 20 20">
                                                        <path id="images" d="M6,2A4,4,0,0,0,2,6V18a4,4,0,0,0,4,4H18a4,4,0,0,0,4-4V6a4,4,0,0,0-4-4ZM6,4H18a2,2,0,0,1,2,2v8.737A4.142,4.142,0,0,0,17,13c-1.293,0-2.448.921-3.563,2.406-.054.072-.071.118-.124.191-.236-.689-.5-1.353-.782-2C11.282,10.737,9.876,9,8,9c-1.632,0-2.919,1.38-3.991,3.447L4,6A2,2,0,0,1,6,4Zm2,7c.749,0,1.781,1.263,2.719,3.406a26.167,26.167,0,0,1,.968,2.656c.1.318.331,1.133.344,1.188a1.006,1.006,0,0,0,1.875.188c.054-.107.16-.3.313-.563a13.537,13.537,0,0,1,.843-1.281C15.823,15.579,16.543,15,17,15s1.177.579,1.937,1.594a14.039,14.039,0,0,1,1.043,1.638A1.978,1.978,0,0,1,18,20H6a1.94,1.94,0,0,1-1.406-.594,1.984,1.984,0,0,1-.563-1.344c.063-.224.2-.733.281-1a26.414,26.414,0,0,1,.969-2.656C6.219,12.263,7.251,11,8,11Zm7-3a1,1,0,1,1,1,1A1,1,0,0,1,15,8Z" transform="translate(-2 -2)" />
                                                    </svg>
                                                </span>
                                            }
                                            Click or drag and drop Image here
                                        </label>
                                        <input type="file" name="imageUrl" id="myFile" class="imgFieldInput" onChange={(e) => this.handleChange(e)} />
                                    </div>
                                    <span className="error-msg">{this.state.error_imageUrl_message}</span>

                                    {this.state.imageUrlPercent > 0 && (
                                        <Progress percent={this.state.imageUrlPercent} />
                                    )}
                                    <a class="link mt-2" href={this.state.imageUrl} target="_blank">{this.state.imageUrl} </a>
                                </div>

                                <div class="advanceOptions">
                                    <label for="">Filters</label>
                                    <button class="add-form" id="add" onClick={(e) => this.handleAddElementInArray(e)}>
                                        <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="feather feather-plus"><line x1="12" y1="5" x2="12" y2="19"></line><line x1="5" y1="12" x2="19" y2="12"></line></svg>
                                    </button>
                                </div>

                                {this.state.filters && this.state.filters.map((row, i) => (
                                    <div class="lookupAdvanceOption">
                                        <div class="w-100 text-right">
                                            <button class="close-form" id="delete" onClick={(e) => this.handleArrayRemove(e, i)}>
                                                <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="feather feather-minus"><line x1="5" y1="12" x2="19" y2="12"></line></svg>
                                            </button>
                                        </div>

                                        <div id="textAreaFields">
                                            <div class="form-group">
                                                <label for="filterKey">Key</label>
                                                <input type="text" name="key" class={`form-control ${this.state.error_key_message ? 'error-input' : ''}`} id="filterKey" value={row.key} onChange={(e) => this.handleArrayValueChange(e.target, i)} />
                                                <span className="error-msg">{this.state.error_key_message}</span>
                                            </div>
                                            <div class="form-group">
                                                <label for="filterText">Text</label>
                                                <textarea class="form-control" name="value" id="filterText" value={row.value} rows="2" onChange={(e) => this.handleArrayValueChange(e.target, i)}></textarea>
                                            </div>
                                        </div>
                                    </div>
                                ))}
                            </div>

                            <div class={`tab-pane ${this.state.platform === 'web' ? "active" : ""}`} id="Web">
                                <div class="form-group">
                                    <label for="shortDetail">Short Description</label>
                                    <input type="text" name="short_description" value={this.state.short_description} class={`form-control ${this.state.error_short_description_message ? 'error-input' : ''}`} id="shortDetail" onChange={(e) => this.handleChange(e)} />
                                    <span className="error-msg">{this.state.error_short_description_message}</span>
                                </div>
                            </div>

                            <div class={`tab-pane ${this.state.platform === 'mobile' ? "active" : ""}`} id="Mobile">
                                <div class="form-group">
                                    <label for="newsDescription">Description</label>
                                    <textarea class={`form-control ${this.state.error_description_message ? 'error-input' : ''}`} name="description" value={this.state.description} id="newsDescription" rows="3" onChange={(e) => this.handleChange(e)}></textarea>
                                    <span className="error-msg">{this.state.error_description_message}</span>
                                </div>

                                <div class='form-group'>
                                    <div class={`ImgField ${this.state.error_imageUrl_message ? 'error-input' : ''}`}>
                                        {this.state.imageUrl &&
                                            <div className="img-holder">
                                                <span class="remove-img" title="Remove News Image" onClick={() => this.removeImage('imageUrl', 'myFile')}>&times;</span>
                                                <img src={this.state.imageUrl} />
                                            </div>
                                        }
                                        <label class="imgFieldArea" for="myFile">

                                            {!this.state.imageUrl &&
                                                <span class="icon fileImg">
                                                    <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 20 20">
                                                        <path id="images" d="M6,2A4,4,0,0,0,2,6V18a4,4,0,0,0,4,4H18a4,4,0,0,0,4-4V6a4,4,0,0,0-4-4ZM6,4H18a2,2,0,0,1,2,2v8.737A4.142,4.142,0,0,0,17,13c-1.293,0-2.448.921-3.563,2.406-.054.072-.071.118-.124.191-.236-.689-.5-1.353-.782-2C11.282,10.737,9.876,9,8,9c-1.632,0-2.919,1.38-3.991,3.447L4,6A2,2,0,0,1,6,4Zm2,7c.749,0,1.781,1.263,2.719,3.406a26.167,26.167,0,0,1,.968,2.656c.1.318.331,1.133.344,1.188a1.006,1.006,0,0,0,1.875.188c.054-.107.16-.3.313-.563a13.537,13.537,0,0,1,.843-1.281C15.823,15.579,16.543,15,17,15s1.177.579,1.937,1.594a14.039,14.039,0,0,1,1.043,1.638A1.978,1.978,0,0,1,18,20H6a1.94,1.94,0,0,1-1.406-.594,1.984,1.984,0,0,1-.563-1.344c.063-.224.2-.733.281-1a26.414,26.414,0,0,1,.969-2.656C6.219,12.263,7.251,11,8,11Zm7-3a1,1,0,1,1,1,1A1,1,0,0,1,15,8Z" transform="translate(-2 -2)" />
                                                    </svg>
                                                </span>
                                            }
                                            Click or drag and drop Image here
                                        </label>
                                        <input type="file" name="imageUrl" id="myFile" class="imgFieldInput" onChange={(e) => this.handleChange(e)} />
                                    </div>
                                    <span className="error-msg">{this.state.error_imageUrl_message}</span>

                                    {this.state.imageUrlPercent > 0 && (
                                        <Progress percent={this.state.imageUrlPercent} />
                                    )}
                                    <a class="link mt-2" href={this.state.imageUrl} target="_blank">{this.state.imageUrl} </a>
                                </div>

                                <div class="advanceOptions">
                                    <label for="">Filters</label>
                                    <button class="add-form" id="add" onClick={(e) => this.handleAddElementInArray(e)}>
                                        <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="feather feather-plus"><line x1="12" y1="5" x2="12" y2="19"></line><line x1="5" y1="12" x2="19" y2="12"></line></svg>
                                    </button>
                                </div>

                                {this.state.filters && this.state.filters.map((row, i) => (
                                    <div class="lookupAdvanceOption">
                                        <div class="w-100 text-right">
                                            <button class="close-form" id="delete" onClick={(e) => this.handleArrayRemove(e, i)}>
                                                <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="feather feather-minus"><line x1="5" y1="12" x2="19" y2="12"></line></svg>
                                            </button>
                                        </div>

                                        <div id="textAreaFields">
                                            <div class="form-group">
                                                <label for="filterKey">Key</label>
                                                <input type="text" name="key" class={`form-control ${this.state.error_key_message ? 'error-input' : ''}`} id="filterKey" value={row.key} onChange={(e) => this.handleArrayValueChange(e.target, i)} />
                                                <span className="error-msg">{this.state.error_key_message}</span>
                                            </div>
                                            <div class="form-group">
                                                <label for="filterText">Text</label>
                                                <textarea class="form-control" name="value" id="filterText" value={row.value} rows="2" onChange={(e) => this.handleArrayValueChange(e.target, i)}></textarea>
                                            </div>
                                        </div>
                                    </div>
                                ))}
                            </div>
                        </div>
                    </div>

                    <div class="slide-btn">
                        <div className="float-left">
                            <button class="close-slide custom-btn semi-dark-btn sm-btn" onClick={e => e.preventDefault()}>Close</button>
                        </div>

                        <div class="float-right">
                            {!this.props.id &&
                                <button class="custom-btn semi-dark-btn sm-btn" onClick={(e) => { e.preventDefault(); this.resetForm() }}>Reset</button>
                            }
                            {this.state.btnIsDisable ?
                                <LoadingButton class_name={"sm-btn"} />
                                :
                                this.props.id ? (
                                    <button class="custom-btn gradiant-btn sm-btn" onClick={(e) => this.onUpdate(e)}>{this.state.btnIsDisable ? "Loading..." : this.state.buttonTitle}</button>
                                ) : (
                                    <button class="custom-btn gradiant-btn sm-btn" onClick={(e) => this.onSave(e)}>{this.state.btnIsDisable ? "Loading..." : this.state.buttonTitle}</button>
                                )}
                        </div>
                    </div>
                </form>
            </div>
        )
    }
}


const mapStateToProps = state => ({
    profile: state.profile
})

const mapDispatchToProps = {
    create,
    update,
    addCurrentRoute
}

export default connect(mapStateToProps, mapDispatchToProps)(Create)